import EditVideoForm from "../../../components/Admin/Videos/EditVideoForm";
import Navbar from "../../../components/Navbar";

export default function EditVideo() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <EditVideoForm />
        </div>
      </section>
    </>
  );
}
